<div class="flex justify-between items-center p-2 border-b">
  <h2 mat-dialog-title class="text-xl font-bold">Configuración de Formularios</h2>
  <button mat-icon-button mat-dialog-close matTooltip="Cerrar">
    <mat-icon svgIcon="heroicons_outline:x-circle"></mat-icon>
  </button>
</div>

<mat-dialog-content class="p-0 max-h-[75vh] flex flex-col overflow-auto">
  <mat-tab-group [(selectedIndex)]="selectedEntityIndex" class="border-b sticky top-0 z-20 bg-white">
    <mat-tab *ngFor="let entity of entities" [label]="getEntityLabel(entity)">
      <ng-container *ngIf="formConfigs[entity]; else noEntityConfig">

        <!-- Tabs Crear / Editar -->
        <mat-tab-group class="sticky top-[48px] bg-white z-10 border-b">
          <mat-tab *ngFor="let tab of ['Create', 'Update']" [label]="getTabLabel(tab)">
            <ng-container *ngIf="formConfigs[entity] && formConfigs[entity][tab] as formGroup;else noFormGroup">
              <form [formGroup]="formConfigs[entity][tab]">
                <ng-container formArrayName="fields">
                  <ng-container *ngIf="getFieldControls(entity, tab).length > 0; else noFields">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div *ngFor="let field of getFieldControls(entity, tab); let i = index" [formGroupName]="i"
                        class="flex flex-col justify-between border rounded p-4 shadow-sm bg-white h-full">

                        <mat-form-field class="w-full" appearance="outline">
                          <mat-label>Etiqueta</mat-label>
                          <input matInput formControlName="label" placeholder="Ej. Nombre del campo"
                            (blur)="onFieldChanged(field.get('_id')?.value, field, entity, tab)" />
                        </mat-form-field>

                        <div class="space-y-3">
                          <app-toggle-option title="Visible" icon="visibility" iconColor="blue"
                            [formControlName]="'visible'" containerClass="mb-3"
                            (valueChange)="onFieldChanged(field.get('_id')?.value, field, entity, tab)">
                          </app-toggle-option>

                          <app-toggle-option title="Requerido" icon="error_outline" iconColor="red"
                            [formControlName]="'required'"
                            (valueChange)="onFieldChanged(field.get('_id')?.value, field, entity, tab)">
                          </app-toggle-option>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #noFields>
                    <p class="text-center text-gray-500 py-4">No hay campos configurados para esta acción.</p>
                  </ng-template>
                </ng-container>
              </form>
            </ng-container>
            <ng-template #noFormGroup>
              <p class="text-center text-gray-500 py-4">No hay configuración para esta acción.</p>
            </ng-template>
          </mat-tab>
        </mat-tab-group>

      </ng-container>
      <ng-template #noEntityConfig>
        <p class="text-center text-gray-500 py-4">No hay configuración para esta entidad.</p>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>